import { render, staticRenderFns } from "./PriceComparison.vue?vue&type=template&id=371b681f&scoped=true&"
import script from "./PriceComparison.vue?vue&type=script&lang=ts&"
export * from "./PriceComparison.vue?vue&type=script&lang=ts&"
import style0 from "./PriceComparison.vue?vue&type=style&index=0&id=371b681f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371b681f",
  null
  
)

export default component.exports